import { UpgradeAdapter } from '@angular/upgrade';
export const upgradeAdapter = new UpgradeAdapter();


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/adapters/upgrade_adapter.ts
 **/